function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "#00B056",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7216 43.8224L68.2987 40.1776L57.2324 50.5704L51.7216 45.395L48.2987 49.0398L57.2324 57.4296L71.7216 43.8224Z",
  fill: "#00B056"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.0101 49C38.0101 36.8497 47.8599 27 60.0102 27C72.1604 27 82.0102 36.8497 82.0102 49C82.0102 52.8576 81.0173 56.4832 79.2732 59.6354L95.038 82.1498L83.2908 81.4897L79.8933 92.7542L64.3598 70.5701C62.9537 70.8521 61.4992 71 60.0102 71C58.6818 71 57.381 70.8823 56.1175 70.6567L40.6447 92.7542L37.2472 81.4897L25.5 82.1498L40.9788 60.0438C39.0912 56.798 38.0101 53.0253 38.0101 49ZM60.0102 67C50.069 67 42.0102 58.9411 42.0102 49C42.0102 39.0589 50.069 31 60.0102 31C69.9513 31 78.0102 39.0589 78.0102 49C78.0102 58.9411 69.9513 67 60.0102 67ZM67.4261 69.7188L78.8058 85.9708L81.1007 78.3619L89.0356 78.8078L77.5052 62.3407C74.9517 65.6843 71.4614 68.2743 67.4261 69.7188ZM42.7879 62.6905C45.4044 65.9777 48.9423 68.4988 53.0108 69.8632L41.7322 85.9708L39.4373 78.3619L31.5024 78.8078L42.7879 62.6905Z",
  fill: "#00B056"
});

function SvgIglWarranty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIglWarranty);
export default __webpack_public_path__ + "static/media/IGLWarranty.6061c4b9.svg";
export { ForwardRef as ReactComponent };